// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-74ac456f] {\n    position: relative;\n    min-height: 340px;\n}\n.placement[data-v-74ac456f] {\n    position: absolute;\n    right: 0;\n}\n.display-block[data-v-74ac456f]{\n      opacity: 1!important;pointer-events : initial!important\n}\n.date-range-picker-small .form-control[data-v-74ac456f]{\n      height: calc(1.5em + .5rem + 2px)!Important;\n      line-height: 1.5;\n}\n", ""]);
// Exports
module.exports = exports;
